import SpriteSymbol from "../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "video_ad-icon",
  "use": "video_ad-icon-usage",
  "viewBox": "0 0 79 57",
  "content": "<symbol viewBox=\"0 0 79 57\" xmlns=\"http://www.w3.org/2000/svg\" id=\"video_ad-icon\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M79 0H0V57H79V0ZM15.0005 6H5.00049V16H15.0005V6ZM15 24H5V34H15V24ZM5 41H15V51H5V41ZM74 6H64V16H74V6ZM64 24H74V34H64V24ZM74 41H64V51H74V41ZM55 28.5L28.75 44.5215V12.4785L55 28.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol